import { ROUTE_SERVICE_CARELEVEL_CALCULATOR, ROUTE_ANALYSE_CARE_LEVEL } from '../constants/routes';

const redirects = [
  {
    path: '/service',
    redirect: () => {
      return { path: ROUTE_SERVICE_CARELEVEL_CALCULATOR };
    },
  },
  {
    path: '/analysen',
    redirect: () => {
      return { path: ROUTE_ANALYSE_CARE_LEVEL };
    },
  },
];

export default redirects;
